<div class="home-popup-wrapper">
    <div class="popup-card">
        <div class="popup-card-header">
            <h5 class="popup-card-title">Get an Illustrative Report</h5>
            <button class="popup-close" (click)="closePopup()" aria-label="Close popup">×</button>
        </div>

        <div class="popup-card-body">
            <img src="images/svg/email-vector.svg" alt="Email Vector" class="popup-vector" />

            <p class="popup-message">
                You haven’t ordered a report — let us email an illustrative report to you.
            </p>

            <form [formGroup]="homeForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <input type="email" class="form-control" formControlName="email" name="email"
                        placeholder="Your Email*">
                    @if(homeForm.get('email')?.invalid &&
                    (homeForm.get('email')?.dirty || homeForm.get('email')?.touched)) {

                    @if(homeForm.get('email')?.errors?.['required']) {
                    <p class="error">Email is required</p>
                    }
                    @if(homeForm.get('email')?.errors?.['email']) {
                    <p class="error">Please enter a valid email</p>
                    }
                    }
                </div>

                <div class="form-group">
                    <input type="text" class="form-control" formControlName="name" name="name" placeholder="Your Name*">
                    @if(homeForm.get('name')?.invalid &&
                    (homeForm.get('name')?.dirty || homeForm.get('name')?.touched)) {

                    @if(homeForm.get('name')?.errors?.['required']) {
                    <p class="error">Name is required</p>
                    }
                    }
                </div>

                <div class="form-group">
                    <input type="tel" class="form-control" formControlName="phone" name="phone"
                        appIntlTelInput [itiOptions]="itiOptions" placeholder="Your Phone Number">
                </div>

                <div class="form-group"><input type="text" class="form-control" formControlName="company" name="company"
                        placeholder="Company"></div>

                <button type="submit" class="btn btn-primary w-100" [disabled]="isSending()">{{isSending() ?
                    'Sending...' : 'Send'}}</button>

                @if (done()) {
                <div class="thanks">
                    <h2>Thank you for your request.</h2>
                    <p>The report has been sent to your email.</p>
                    If you didn't receive it please <a routerLink="/contact-us">contact us</a>
                </div>
                }
            </form>
        </div>
    </div>
</div>
